import "../Cash";
import $ from "cash-dom";
import { getAPIRequest } from "../CarsForSale/API/Helpers";
import { updateQueryString } from "./functions";

type SlidersProps = {
  min_price: number;
  max_price: number;
  min_miles: number;
  max_miles: number;
};

export class Sorting {
  page: number;
  carModel: URLSearchParams;
  currentURL: string;
  filters: URLSearchParams;

  constructor(isGeo: boolean) {
    let params = this.getParamsFromURL(isGeo);
    this.page = parseInt(params.get("page")) || 1;
    params.delete("page");
    this.carModel = params;
    this.currentURL = `${location.protocol}//${location.host}${location.pathname}`;
    this.filters = new URLSearchParams(window.location.search);
  }

  public sortBy(params) {
    params.forEach((value: string, key: string) => {
      this.filters.set(key, value);
    });
    if (this.page > 1) {
      return this.redirectTo(null, params);
    }
    this.updateCurrentURL(this.filters);
    this.getSortedCards(this.carModel + "&" + this.filters.toString());
    this.updatePaginationLinks(this.filters.toString());
  }

  public addFilter(key: string, value: string, append: boolean = false) {
    if (value && !append) {
      this.filters.set(key, value);
    } else if (value && append && !this.filters.getAll(key).includes(value)) {
      this.filters.append(key, value);
    } else if (value == "false") {
      this.filters.delete(key);
    }
  }

  public clearFilter(key: string) {
    this.filters.delete(key);
  }

  public filter(key: string = null, value: string = null) {
    if (key) {
      this.addFilter(key, value);
      if (!value) {
        this.clearFilter(key);
      }
    }
    this.removeErrorAlert();
    this.updateCurrentURL(this.filters);
    this.getSortedCards(this.carModel + "&" + this.filters.toString());
  }

  public redirectTo(pageType, params) {
    let url = new URL(this.currentURL);
    if (pageType == "make") {
      url.pathname = `/cars-for-sale/${params[0]}`;
    } else if (pageType == "model") {
      url = new URL(this.currentURL);
      url.pathname += `/${params[0]}`;
    } else if (params != null) {
      this.filters.delete("page");
      return window.location.replace(
        this.currentURL + `?${this.filters.toString()}`
      );
    }
    window.location.replace(url);
  }

  private updateCurrentURL(params: URLSearchParams) {
    if (this.page > 1) {
      params.set("page", this.page.toString());
    }
    const newUrlString = `${this.currentURL}?${params.toString()}`;
    const newUrl = new URL(newUrlString);
    window.history.pushState({ path: newUrl.href }, "", newUrl.href);
  }

  async getSortedCards(paramsString) {
    let carList = $("#car-list");
    this.setLoadingCards(carList);
    paramsString = paramsString.replace(/page=\d+/, 'page=1');
    $('#load-more-div-top').addClass('is-hidden');
    const response = await fetch(
      `${location.protocol}//${location.host}/cars-for-sale/api/v2/cars?${paramsString}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }
    );
    updateQueryString("page", null);
    const jsonData = await response.json();
    (window as any).totalPages = jsonData.total_pages;

    if (jsonData.total_pages == 1) {
      $('#load-more-div-bottom').addClass('is-hidden');
    }

    if (jsonData.returnedResults == 0) {
      var now = new Date();
      now.setTime(now.getTime() + 5 * 1000);
      document.cookie =
        "error_notification=true;expires=" + now.toUTCString() + ";";
      this.redirectTo(null, null);
    } else {
      carList.empty();
      
      if (jsonData.carComponents && jsonData.carComponents.length > 0) {
        const group = $('<div></div>')
        group.addClass('columns is-multiline is-mobile mt-4')
        group.attr('data-page', '1');
        jsonData.carComponents.forEach((carComponent) => {
          group.append(carComponent);
        });
        carList.append(group) 

      } else {
        carList.append(`<div class="column is-12" style="text-align: center;">
          <p class="has-text-weight-bold">No cars available.</p>
        </div>`);
      }

      $("nav.pagination").html(jsonData.pagination);
    }
  }

  private updatePaginationLinks(params: string) {
    let currentURL = this.currentURL;
    let paginationLinks = $("a.pagination-link");
    paginationLinks.each(function () {
      let href = $(this).attr("href");
      let page = new URL(href).searchParams.get("page");
      if (href != null) {
        $(this).attr("href", `${currentURL}?${params}&page=${page}`);
      }
    });
  }

  private setLoadingCards(list) {
    list.empty();
    const loadingCardsContainer = $('<div></div>')
    .addClass('columns is-multiline is-mobile mt-4 loading-card')
    for (let index = 0; index < 6; index++) {
        loadingCardsContainer.append(this.loadingCardComponent());
    }
      list.append(loadingCardsContainer);

  }

  private loadingCardComponent() {
    return `
      <div class="column is-4-desktop is-6-tablet is-12-mobile">
      <div id="card-data" class="card card--car p-0">
        <div class="columns is-mobile is-multiline">
          <div class="column is-12 pt-0">
            <div class="skeleton skeleton-rect" style="
                        --rect-h: 190px;
                        --l-h: 40px;
                        --lines: 1;
                    "></div>
            <div class="skeleton skeleton-line" style="--l-h: 40px;"></div>
            <div class="skeleton skeleton-line" style="
                        --c-bg: #F8F7FC;
                        --lines: 5;
                    "></div>
            <div class="skeleton skeleton-line my-3" style="--l-h: 40px;"></div>
          </div>
        </div>
      </div>
    </div>
    `;
  }

  public removeErrorAlert() {
    if ($("#notification-alert").length > 0) {
      $("#notification-alert").remove();
    }
  }

  public getParamsFromURL(isGeo: boolean) {
    let segments = window.location.pathname.split("/").slice(2);
    let make = segments.shift(); //First element is always the make
    if (isGeo) {
      var location = segments.pop(); // Last element is the location
      var model = segments.pop();
    } else {
      if (segments.length == 1) {
        var model = segments.pop();
      } else {
        var year = segments.pop();
        var model = segments.pop();
      }
    }
    let queryParams = new URLSearchParams(window.location.search);
    let page = queryParams.get("page");

    const data = {
      make: make,
      model: model,
      year: year,
      location: location,
      page: page,
    };

    Object.keys(data).forEach((key) => {
      if (data[key] == null) {
        delete data[key];
      }
    });

    return new URLSearchParams(data);
  }

  public initializeFilters() {
    let queryParams = new URLSearchParams(window.location.search);
    queryParams.forEach((value: string, key: string) => {
      if (key.startsWith("year")) {
        $(`select[name="${key}"]`).val(value).trigger("change");
      } else if ($(`input[name="${key}"]`).attr("type") == "checkbox") {
        $(`input[name="${key}"][value="${value}"]`).prop("checked", true);
      } else {
        $(`input[name="${key}"]`).val(value);
      }
    });
  }

}
